import { Flex, Text } from "@chakra-ui/react";
import { Table, ColumnDefinition } from "barte-design-system";
import { formatCurrency, formatDate } from "@/utils";

interface StatementCharge {
  amount: number;
  creditOperation: boolean;
  description: string;
  executionDate: string;
  providerType: string;
  statementType: string;
}

interface ReceivableRow {
  amount: number;
  description: string;
  executionDate: string;
}

interface StatementChargeProps {
  statementCharge: StatementCharge[];
}

const toCents = (amount: number) => Math.round((amount ?? 0) * 100);

const groupByExecutionDate = (statementCharge: StatementCharge[]) => {
  const groups = new Map<string, StatementCharge[]>();

  statementCharge
    ?.filter((item) => item?.executionDate)
    .forEach((item) => {
      const group = groups.get(item.executionDate) ?? [];
      group.push(item);
      groups.set(item.executionDate, group);
    });

  return Array.from(groups.entries())
    .map(([executionDate, statements]) => ({
      executionDate,
      description: statements[0]?.description,
      amount:
        statements.reduce((total, item) => total + toCents(item?.amount), 0) /
        100,
    }))
    .sort((a, b) => a.executionDate.localeCompare(b.executionDate));
};

const columns: ColumnDefinition<ReceivableRow>[] = [
  {
    key: "description",
    title: "Parcela",
    dataIndex: "description",
    render: (v) => v || "-",
  },
  {
    key: "amount",
    title: "Valor",
    dataIndex: "amount",
    render: (v: number) => (
      <Text
        fontSize="sm"
        color={v < 0 ? "var(--accent-red)" : "var(--content-primary)"}
      >
        {formatCurrency({ value: v })}
      </Text>
    ),
  },
  {
    key: "executionDate",
    title: "Data de execução",
    dataIndex: "executionDate",
    render: (v) => formatDate(v as string) ?? "-",
  },
];

const ReceivableTable = ({ statementCharge }: StatementChargeProps) => {
  const receivables = groupByExecutionDate(statementCharge);

  return (
    <Flex direction="column" gap="4" w="full">
      <Text fontWeight="bold" fontSize="16px" color="#0f172a">
        Recebíveis
      </Text>
      <Table
        data={receivables}
        columns={columns}
        rowKey={(r) => r.executionDate}
      />
    </Flex>
  );
};

export { ReceivableTable };
